// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191134/js/" + chunkId + "." + {"44":"30b5bee7","225":"fff3511e","481":"4b4be4d4","486":"7b1cd90e","770":"a96e5366"}[chunkId] + ".0.2911460391530929.chunk.js";
};